export default ( event, coBrandedCard, clubpremierID, sectionName  ) => {
  return {
    event: event,
    coBrandedCard: coBrandedCard,
    clubpremierID: clubpremierID,
    sectionName: sectionName,
  };
};
